import React from 'react';
import { Link } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons';
import {
    buildGroupedMenuItems,
    resolveMenuSelectedKey,
    resolveOpenGroupKeys,
} from './moduleMenu';

/**
 * 根据当前用户构建 Ant Design Menu items（含分组 children）。
 * @param {object|null} user
 */
export function buildAdminMenuItems(user) {
    const groups = buildGroupedMenuItems(user, (path, label) => (
        <Link to={path}>{label}</Link>
    ));
    return [
        ...groups,
        { type: 'divider' },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            danger: true,
        },
    ];
}

export { resolveMenuSelectedKey, resolveOpenGroupKeys };
